import { render, staticRenderFns } from "./x-toggle-panel.component.vue?vue&type=template&id=06ccafb4&scoped=true"
import script from "./x-toggle-panel.component.vue?vue&type=script&lang=ts"
export * from "./x-toggle-panel.component.vue?vue&type=script&lang=ts"
import style0 from "./x-toggle-panel.component.vue?vue&type=style&index=0&id=06ccafb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ccafb4",
  null
  
)

export default component.exports